import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

export const GetClustersInfoRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HostTools/GetClustersInfo`,
	params: { userId }
});

export const GetClusterStringRequest = (userId, mocnActivationDates, host) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HostTools/GetClusterString`,
	params: { userId, mocnActivationDates, host }
});

// SiteList
export const GetSiteListDatesRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HostTools/GetSiteListDates`,
	params: { userId }
});

export const GetSiteListRequest = (userId, mocnActivationDateF) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HostTools/GetSiteList`,
	params: { userId, mocnActivationDateF }
});

